/*
Author: Nishant Singh
Description: Every reducer name should be name followed by suffix Reducer with camelCase.
*/
import { createReducer } from '@reduxjs/toolkit';
import {
  SET_VOUCHER,
  RESET_VOUCHER,
  SET_SELECT_VOUCHER,
  SET_AUTO_APPLY_VOUCHER,
  SET_BANK_PROMO,
  RESET_BANK_PROMO,
  RESET_VOUCHER_DETAIL,
  REQUEST_VOUCER_LIST,
} from '../actions/voucher';
// ........States
const initialState = {
  categoryVouchers: [],
  voucherDetail: null,
  voucherSelect: null,
  bankPromo: null,
  voucherList: [],
  status: {
    categoryVouchers: 'idle',
    voucherDetail: 'idle',
    bankPromo: 'idle',
    voucherList: 'idle',
  },
};

const voucherReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(`cart/categoryVouchers/pending`, (state) => {
      state.status.categoryVouchers = 'loading';
    })
    .addCase(`cart/categoryVouchers/fulfilled`, (state, action) => {
      state.categoryVouchers = action.payload;
      state.status.categoryVouchers = 'succeeded';
    })
    .addCase(`${SET_VOUCHER}/pending`, (state) => {
      state.status.voucherDetail = 'pending';
    })
    .addCase(`${SET_VOUCHER}/fulfilled`, (state, action) => {
      state.voucherDetail = action.payload;
      state.status.voucherDetail = 'succeeded';
    })
    .addCase(`${SET_VOUCHER}/rejected`, (state) => {
      state.status.voucherDetail = 'failed';
    })
    .addCase(`${RESET_VOUCHER}/pending`, (state) => {
      state.status.voucherDetail = 'pending';
    })
    .addCase(`${RESET_VOUCHER}/fulfilled`, (state) => {
      state.voucherDetail = null;
      state.status.voucherDetail = 'succeeded';
    })
    .addCase(`${SET_SELECT_VOUCHER}`, (state, action) => {
      state.voucherSelect = action.payload;
    })
    .addCase(`${SET_AUTO_APPLY_VOUCHER}`, (state, action) => {
      state.voucherDetail = action.payload;
    })
    .addCase(`${SET_BANK_PROMO}/pending`, (state) => {
      state.status.bankPromo = 'pending';
    })
    .addCase(`${SET_BANK_PROMO}/fulfilled`, (state, action) => {
      state.bankPromo = action.payload;
      state.status.bankPromo = 'succeeded';
    })
    .addCase(`${RESET_BANK_PROMO}/pending`, (state) => {
      state.status.bankPromo = 'pending';
    })
    .addCase(`${RESET_BANK_PROMO}/fulfilled`, (state) => {
      state.bankPromo = null;
      state.status.bankPromo = 'succeeded';
    })
    .addCase(`${RESET_VOUCHER_DETAIL}`, (state, action) => {
      state.bankPromo = null;
      state.voucherDetail = null;
    })
    .addCase(`${REQUEST_VOUCER_LIST}/pending`, (state) => {
      state.status.voucherList = 'pending';
    })
    .addCase(`${REQUEST_VOUCER_LIST}/fulfilled`, (state, action) => {
      state.voucherList = action.payload;
      state.status.voucherList = 'succeeded';
    })
    .addCase(`${REQUEST_VOUCER_LIST}/rejected`, (state) => {
      state.status.voucherList = 'failed';
    })
    .addDefaultCase((state) => state);
});

export default voucherReducer;
